var exports = {
  "KE": "HeroSection__R4eqX9",
  "p1": "HeroSection--hasBottomBorder__y6I3hu",
  "yl": "HeroSection__Spacer__JegAKV",
  "w6": "HeroSection__Spacer--short__EbVRZP",
};

module.exports = exports;
